import { combineReducers } from 'redux'
import PupilsReducer from './components/pages/pupils/pupils.reducer'
import PupilsStoreReducer from './stores/pupils/pupils.reducer'
import PupilStoreReducer from './stores/pupil/pupil.reducer'
import PupilProfileReducer from './stores/profile/profile.reducer'
import PermissionsReducer from './stores/permissions/permissions.reducer'
import CommentsReducer from './stores/comments/comments.reducer'
import WorksReducer from './stores/works/works.reducer'
import AssessmentReducer from './stores/assessment/assessment.reducer'
import GroupsReducer from './stores/groups/groups.reducer'
import GroupsComponentReducer from './components/pages/groups/groups-component-redux/groups-component-redux.reducer'
import PupilsComponentReducer from './components/pupils-component/pupils-component-redux/pupils-component.reducer'
import YearGroupsReducer from './stores/year-groups/year-groups.reducer'
import AddToGroupDialogReducer from './components/add-to-group/add-to-group.reducer'
import ConflictsReducer from './stores/conflict-resolution/conflict-resolution.reducer'

const Reducer = combineReducers({
  Shared: combineReducers({
    AddToGroupDialog: AddToGroupDialogReducer
  }),
  PupilsComponent: PupilsComponentReducer,
  GroupsComponent: GroupsComponentReducer,
  Pupils: PupilsReducer,
  PupilStore: PupilStoreReducer,
  CommentsStore: CommentsReducer,
  WorksStore: WorksReducer,
  AssessmentStore: AssessmentReducer,
  PermissionsStore: PermissionsReducer,
  PupilsStore: PupilsStoreReducer,
  PupilProfileStore: PupilProfileReducer,
  GroupsStore: GroupsReducer,
  YearGroups: YearGroupsReducer,
  ConflictsStore: ConflictsReducer
})

export default Reducer
